const id_master_groups = {
    add: "tambah kelompok",
    edit: "ubah kelompok",
    name: "nama kelompok",

    error: {
        category: "Kategori kelompok tidak boleh kosong.",
        create: "Gagal membuat kelompok.",
        delete: "Gagal menghapus kelompok.",
        edit: "Gagal mengubah kelompok.",
        name: "Nama kelompok tidak boleh kosong.",
        po_duration: "Lama pre-order harus lebih dari 0.",
        unit: "Satuan kelompok tidak boleh kosong.",
        type: "Tipe kelompok tidak boleh kosong.",
        whs1: "Gudang kelompok tidak boleh kosong.",
        whs2: "Minimal terdapat 1 gudang.",
    },

    success: {
        create: "Berhasil membuat kelompok.",
        delete: "Berhasil menghapus kelompok.",
        edit: "Berhasil mengubah kelompok.",
    }
}

export default id_master_groups